module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('div', {
    staticClass: "SOM_titre"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("The dates of Kings and Prophets")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Key to Panels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3#niv1-001"
    }
  }, [_vm._v("Think about’ Panels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3#niv1-002"
    }
  }, [_vm._v("‘Digging deeper’ Panels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3#niv1-003"
    }
  }, [_vm._v("Other Panels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-004"
    }
  }, [_vm._v("What this book aims to do")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-005"
    }
  }, [_vm._v("Studying the prophetic books")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-003"
    }
  }, [_vm._v("Prophets and books")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-004"
    }
  }, [_vm._v("The Prophet")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-005"
    }
  }, [_vm._v("The book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-006"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-007"
    }
  }, [_vm._v("Rhetorical intention: prophetic ‘art’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-008"
    }
  }, [_vm._v("Canonical context")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-006"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-009"
    }
  }, [_vm._v("Introductions to the Old Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-010"
    }
  }, [_vm._v("Interpreting the Old Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-011"
    }
  }, [_vm._v("One-volume Bible commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-012"
    }
  }, [_vm._v("Books on the Prophets")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv2-013"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-007"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('span', {
    attrs: {
      "href": "#/pre5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Isaiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Isaiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Identifying Isaiah of Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The message of Isaiah of Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The composition of Isaiah 1—39")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 1—39 and 40—66")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Isaiah as a unity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ‘story’ behind the book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zion, city of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King and Messiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The servant and the nations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trust in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah in the Canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#niv2-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Jeremiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Jeremiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy as poetry?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Deuteronomistic’ sermons?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A deuteronomistic edition?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Jeremiah from Jeremiah?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sin as falseness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgement and salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The new covenant")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The individual")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Messiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah in the Canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Lamentations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Lamentations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covenant curse and confession of Sin")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamentation and bitter suffering")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘The steadfast love of the Lord’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting for God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A comforter")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamentations in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Ezekiel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Place")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To whom is he speaking?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Ezekiel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sovereignty of God and human responsibility")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The presence of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sin, judgement, purification")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salvation: a radically new beginning; Zion and Eden")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Political/formal and spiritual religion: Ezekiel as Prophet and Priest")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ezekiel in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Daniel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Daniel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genre")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The kingdom of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine and human rule")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Messiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s faithfulness, human faithfulness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Daniel in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The book of the twelve")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Hosea")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion in hosea’s time")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Hosea")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘No other Gods’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faithfulness and steadfast love")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgement and love: God’s dilemma")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hosea in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Joel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Joel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-powerful God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THe ‘day of the Lord’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repentance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nature and history")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The spirit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joel in the Canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8#niv2-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Amos")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Amos")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and righteousness, and the ‘good’ of God’s people")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and creation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The universal God and the election of Israel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical devices")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical levels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amos in the Canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv1-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9#niv2-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Obadiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv2-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject matter")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv2-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vocabulary and ideas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Obadiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv2-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv2-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obadiah in the Canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv1-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv2-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#niv2-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Jonah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dating and genre")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Jonah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working out the sovereignty of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worship and thanksgiving")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retribution?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s forgiveness extended to all?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can God ‘repent’?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘God’ and ‘Yahweh’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah in the Canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv1-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#niv2-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Micah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Micah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgement and salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exodus and covenant traditions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophetic ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The nations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Micah in the Canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv1-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12#niv2-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Nahum")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Nahum")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nahum in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv1-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13#niv2-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Habakkuk")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Habakkuk")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How can a just god tolerate evil?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("’The righteous shall live by (whose?) faithfulness’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Habakkuk in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv1-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14#niv2-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Zephaniah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Zephaniah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zephaniah a ‘drama’?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zephaniah a ‘cult-prophet’?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s election of israel, and his kingship in the world")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More on election: a ‘remnant’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion and ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The day of the lord: judgement and salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zephaniah in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv1-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15#niv2-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Haggai")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Haggai")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv2-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv2-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv2-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The temple")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv2-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future hope")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haggai in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv1-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv2-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16#niv2-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Zechariah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah 1—8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah 9—14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Zechariah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah 1—8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah 1—8 and 9—14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Between salvation and salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Messiah")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zechariah in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv1-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17#niv2-156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv1-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Date and destination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv1-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Critical interpretation of Malachi")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv1-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure and outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv1-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological themes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covenant with Yahweh")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Particular covenants")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Form and spirit in worship")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eschatology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv1-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical intention")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv1-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malachi in the canon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv1-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18#niv2-164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other books and articles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Exploring the Old Testament: A Guide to the Prophets")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books in this Series")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident13#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0